import React from 'react';

import gsap from 'gsap';

// styles
import './chartQuestions.scss';

const ChartQuestions = () => {
  const handleClick = (anchor: string) => {
    gsap.to(window, {
      duration: 1,
      scrollTo: anchor,
      onComplete: () => {
        location.hash = anchor;
      },
    });
  };

  return (
    <div className="chartQuestions-wrapper">
      <div id="chart-questions" className="chartcontainer-anchor"></div>
      <div className="chartQuestions">
        <div className="grid-row">
          <div className="grid-cell xs-12 md-3">
            <div className="chartQuestion">
              <div className="chartQuestion-number">1.</div>
              <div className="chartQuestion-content">
                <div className="chartQuestion-text">Wie hat sich die Einkommensverteilung in der Schweiz von 1917 bis heute entwickelt?</div>
                <a href="javascript:void(0);" onClick={(e) => handleClick('#graph-1')} className="chartQuestion-link">
                  MEHR ERFAHREN
                </a>
              </div>
            </div>
          </div>
          <div className="grid-cell xs-12 md-3">
            <div className="chartQuestion">
              <div className="chartQuestion-number">2.</div>
              <div className="chartQuestion-content">
                <div className="chartQuestion-text">Wie stark verändert der Staat die Einkommensverteilung durch Umverteilung?</div>
                <a href="javascript:void(0);" onClick={(e) => handleClick('#graph-2')} className="chartQuestion-link">
                  MEHR ERFAHREN
                </a>
              </div>
            </div>
          </div>
          <div className="grid-cell xs-12 md-3">
            <div className="chartQuestion">
              <div className="chartQuestion-number">3.</div>
              <div className="chartQuestion-content">
                <div className="chartQuestion-text">Wie ist das Steueraufkommen in der Schweiz verteilt?</div>
                <a href="javascript:void(0);" onClick={(e) => handleClick('#graph-3')} className="chartQuestion-link">
                  MEHR ERFAHREN
                </a>
              </div>
            </div>
          </div>
          <div className="grid-cell xs-12 md-3">
            <div className="chartQuestion">
              <div className="chartQuestion-number">4.</div>
              <div className="chartQuestion-content">
                <div className="chartQuestion-text">Ab welchem Einkommen zählt man zu den obersten Einkommensgruppen?</div>
                <a href="javascript:void(0);" onClick={(e) => handleClick('#graph-4')} className="chartQuestion-link">
                  MEHR ERFAHREN
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartQuestions;
